import { firebaseFunctionsService } from "@infrastructure/firebase/firebaseFunctionsService";

export type RequestAccountDeletionResult = {
  requested: true;
  alreadyRequested: boolean;
};

export async function requestAccountDeletion(): Promise<RequestAccountDeletionResult> {
  const result = await firebaseFunctionsService.callFunctionWithData("requestAccountDeletion", {});
  return result.data as RequestAccountDeletionResult;
}
